import React from "react";
import { FrontColors } from "../../../models/FrontColors";
import { FrontSpacing } from "../../../models/FrontSpacing";
import { Flex } from "../../BuildingBlocks/Flex";
import { FontQuicksand } from "../../BuildingBlocks/FontQuicksand";
import { FontSize } from "../../BuildingBlocks/FontSize";
import { MaxWidth } from "../../BuildingBlocks/MaxWidth";
import { SpacingColumn } from "../../BuildingBlocks/SpacingColumn";
import { TextAlign } from "../../BuildingBlocks/TextAlign";
import { TextColor } from "../../BuildingBlocks/TextColor";
import { WeightSemiBold } from "../../WeightSemiBold/WeightSemiBold";
import { WeightBold } from "../../WeightBold/WeightBold";
import { FPLandingTitle } from "../Simple/FPLandingTitle/FPLandingTitle";
import { FPSimpleLogo } from "../Simple/FPSimpleLogo/FPSimpleLogo";

const STEPS: Array<{ heading: string, body: JSX.Element }> = [
    {
        heading: "We check the property",
        body: <>We pull the official Land Registry title and look at what similar homes nearby have sold for.</>,
    },
    {
        heading: "We ring your client",
        body: <>We talk them through how we got to the figure, and answer anything they want to ask.</>,
    },
    {
        heading: "They get it in writing",
        body: <>In the format the grant application needs. If HMRC ever ask about it, we deal with that. It won't come back to you.</>,
    },
];

export const FPPropertyReportValuationBooked = (): JSX.Element =>
    <SpacingColumn
        spacing={FrontSpacing.LARGE_1}
        justifyContent="center"
    >
        {/* LOGO */}
        <Flex justifyContent="center">
            <FPSimpleLogo width="95px" />
        </Flex>

        {/* HEADER */}
        <Flex justifyContent="center">
            <MaxWidth width="530px">
                <FPLandingTitle
                    size={60}
                    color={FrontColors.NEUTRAL_18}
                    align="center"
                >
                    That's with us.
                </FPLandingTitle>
            </MaxWidth>
        </Flex>

        {/* INTRO */}
        <Flex justifyContent="center">
            <MaxWidth width="425px">
                <TextColor color={FrontColors.NEUTRAL_18}>
                    <TextAlign position="center">
                        <FontQuicksand>
                            <FontSize size={20} lineHeight={1.2}>
                                <WeightSemiBold>
                                    <WeightBold>Thanks, that's your valuation booked.</WeightBold> We have the property and your client's details. <WeightBold>There's nothing else for you to do.</WeightBold>
                                </WeightSemiBold>
                            </FontSize>
                        </FontQuicksand>
                    </TextAlign>
                </TextColor>
            </MaxWidth>
        </Flex>

        {/* WHAT HAPPENS NEXT */}
        <Flex justifyContent="center">
            <MaxWidth width="425px">
                <SpacingColumn spacing={FrontSpacing.MEDIUM_1}>
                    {STEPS.map((step, i) =>
                        <TextColor key={i} color={FrontColors.NEUTRAL_18}>
                            <TextAlign position="center">
                                <FontQuicksand>
                                    <FontSize size={18} lineHeight={1.3}>
                                        <WeightBold>{i + 1}. {step.heading}</WeightBold>
                                        {" "}
                                        {step.body}
                                    </FontSize>
                                </FontQuicksand>
                            </TextAlign>
                        </TextColor>
                    )}
                </SpacingColumn>
            </MaxWidth>
        </Flex>
    </SpacingColumn>;
